import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Text, Box, Flex, Button, VectorRightIcon, useMatchBreakpoints } from 'uikit'
import { useTranslation } from 'contexts/Localization'

const ModelBg = styled(Box)`
  ${({ theme }) => theme.mediaQueries.lg} {
    background-image: url('/images/home/intro-bg.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
`

const Title = styled(Text)`
  font-weight: 600;
  font-size: 30px;
  line-heigth: 40px;

  ${({ theme }) => theme.mediaQueries['2sm']} {
    font-weight: 300;
    font-size: 50px;
    line-heigth: 65px;
  }
`

const Purple = styled.span`
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primary};
`

const Bold = styled.span`
  font-weight: bold;
`

const Model = styled.img`
  width: 280px;

  ${({ theme }) => theme.mediaQueries['2sm']} {
    width: 420px;
  }

  ${({ theme }) => theme.mediaQueries['2xl']} {
    width: 555px;
  }
`

const Intro: React.FC = () => {
  const { t } = useTranslation()
  const { isXs, is2sm } = useMatchBreakpoints()

  return (
    <ModelBg>
      <Flex
        py={['48px', null, null, null, '185px']}
        px={['30px', null, '40px']}
        justifyContent="space-between"
        mx="auto"
        alignItems="center"
        maxWidth="1380px"
        flexDirection={['column', null, null, null, null, null, 'row']}
      >
        {(isXs || is2sm) && <Model src="/images/home/intro-model.png" alt="intro-model" />}
        <Box>
          {!(isXs || is2sm) && (
            <Text fontSize="25px" fontWeight="400" color="textSecondary">
              {t('Quality. Transparency. Trusted.')}
            </Text>
          )}
          <Title mt={['48px', null, '24px']}>
            <Purple>DarkMatterDeFi</Purple>
          </Title>
          <Title>{t('The Next Generation')}</Title>
          <Text mt="10px" fontSize="18px" fontWeight="300" maxWidth="500px">
            <Bold>{t('Earn. NFT. Launchpad.')}</Bold>{' '}
            {!(isXs || is2sm) && t('Providing useful DeFi Services to our Alien community.')}
          </Text>
          <Flex mt="70px" flexDirection={['column', null, 'row']}>
            <Button
              as={Link}
              to="/swap?outputCurrency=0x90e892fed501ae00596448aecf998c88816e5c0f"
              height="40px"
              width={['100%', null, '150px']}
              mr="8px"
            >
              {t('Get DMD')}
            </Button>
            <Button
              as={Link}
              to="/nft/launchpad"
              height="40px"
              variant="text"
              color="white"
              endIcon={<VectorRightIcon />}
              mt={['24px', null, '0']}
            >
              <Text>{t('Launchpad')}</Text>
            </Button>
          </Flex>
        </Box>
        {!(isXs || is2sm) && <Model src="/images/home/intro-model.png" alt="intro-model" />}
      </Flex>
    </ModelBg>
  )
}

export default Intro
